import { toast } from 'react-toastify';
import { useRef } from 'react';

export const useToast = () => {
  const lastToastTime = useRef<{ [key: string]: number }>({});
  const THROTTLE_TIME = 2000; // 2 giây

  const showThrottledToast = (type: 'success' | 'error' | 'warning' | 'info', message: string) => {
    const now = Date.now();
    const lastTime = lastToastTime.current[type] || 0;
    
    if (now - lastTime < THROTTLE_TIME) {
      return; // Bỏ qua nếu chưa đủ thời gian
    }
    
    lastToastTime.current[type] = now;
    
    toast[type](message, {
      position: "top-right",
      autoClose: type === 'error' ? 4000 : 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const showSuccess = (message: string) => {
    showThrottledToast('success', message);
  };

  const showError = (message: string) => {
    showThrottledToast('error', message);
  };

  const showWarning = (message: string) => {
    showThrottledToast('warning', message);
  };

  const showInfo = (message: string) => {
    showThrottledToast('info', message);
  };

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};
